import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal.jsx';
import { ABOUT_LEDE, PRINCIPLES, LEADERSHIP } from '../content/site.js';

export default function About() {
  return (
    <>
      <section className="page-head">
        <div className="shell">
          <p className="eyebrow">About Ennoveda</p>
          <h1>Brilliance at the Basics</h1>
          <p className="lede" style={{ marginTop: '1.2rem', maxWidth: '44rem' }}>{ABOUT_LEDE}</p>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="grid grid-3">
            {PRINCIPLES.map(([title, body], i) => (
              <Reveal key={title} delay={i * 80}>
                <div className="card">
                  <h3>{title}</h3>
                  <p className="dim" style={{ marginTop: '0.6rem' }}>{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <Reveal>
            <p className="eyebrow">Leadership</p>
            <h2>The people behind the promise</h2>
            <p className="lede" style={{ marginTop: '1rem' }}>
              Real engineers, real accountability.
            </p>
          </Reveal>
          <div className="grid grid-3" style={{ marginTop: '2.5rem' }}>
            {LEADERSHIP.map((person, i) => (
              <Reveal key={person.name} delay={i * 80}>
                <div className="card person">
                  <h3>{person.name}</h3>
                  <p className="eyebrow eyebrow-grey" style={{ margin: '0.4rem 0 0.8rem' }}>{person.role}</p>
                  <p className="dim">{person.bio}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <Reveal className="cta">
            <h2>Get in touch</h2>
            <p className="lede" style={{ marginTop: '1rem' }}>
              Tell us what you are trying to solve and we will point you in the right direction —
              even if that turns out not to be us.
            </p>
            <p style={{ marginTop: '1.8rem' }}>
              <Link to="/contact" className="btn btn-primary">Contact us</Link>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
